import { httpRequest } from "../../../utils/HttpRequest";
import { ISearchPage, IPage, IMdCmFields } from "@/types/FmsTypes";
import { LONG_REQUEST_TIMEOUT } from "@/utils/constants";

//详情
export interface IIntervalDetail {
    id: string,              
}


//搜索条件
export interface IIntervalSearchFields {
   
}

export interface IIntervalSearch
    extends IIntervalSearchFields, ISearchPage {
}


class IntervalService {
    async page(searchVo: IIntervalSearch) {
        const apiUrl = "/Interval/page";
        return await httpRequest.post1<IPage<IIntervalDetail>>(apiUrl, searchVo);
    }
    //导出
    async export(searchVo: IIntervalSearch) {
        const apiUrl = "/Interval/exprot";
        return await httpRequest.postFile<boolean>(apiUrl, searchVo, { timeout: LONG_REQUEST_TIMEOUT });
    }
}

export const intervalService = new IntervalService();
